import fetch from "../fetch";

export default ({ saleId }) =>
  fetch({ method: "DELETE", path: `/re/sales/${saleId}` });
